import { z } from "zod";

export const forgotPasswordRequestSchema = z.object({
  email: z.email("Valid email is required"),
});
